<template>
  <section class="case-creation pt-15" v-loading="loading">
    <div class="container-sm">
      <!-- ! Patient Information || Case Creation -->
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Patient Information</h3>
            </div>
          </div>
          <PatientInformation
            v-if="showDob"
            :patientInfo="patientInformation"
            @updateInsurance="updatePatientData"
            ref="patientInformationForm"
          ></PatientInformation>
        </div>
      </div>
      <span class="case-creation__divider"></span>

      <!-- ! Case Information || Case Creation -->
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Case Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-form">
              <div style="display: flex; gap: 12px; font-family: sans-serif">
                <div>
                  <p style="margin: 0; font-weight: 500">STAT Case</p>
                </div>
                <div>
                  <label
                    style="
                      position: relative;
                      display: inline-block;
                      width: 50px;
                      height: 28px;
                    "
                  >
                    <input
                      type="checkbox"
                      v-model="caseInformation.is_stat"
                      style="opacity: 0; width: 0; height: 0"
                    />
                    <span
                      :style="`
                        position: absolute;
                        cursor: pointer;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: 20px;
                        width: 36px;
                        background-color: ${
                          caseInformation.is_stat ? '#4ade80' : '#f2f2f2'
                        };
                        border : ${
                          caseInformation.is_stat ? '#4ade80' : '#f2f2f2'
                        };
                        border-radius: 34px;
                        transition: 0.4s;
                        display: flex;
                        align-items: center;
                        padding: 0 4px;
                      `"
                    >
                      <span
                        :style="`
                          height: 20px;
                          width: 20px;
                          background-color: ${
                            caseInformation.is_stat ? '#f2f2f2' : 'white'
                          };
                          border-radius: 50%;
                          transition: 0.4s;
                          transform: translateX(${
                            caseInformation.is_stat ? '22px' : '0'
                          });
                        `"
                      ></span>
                    </span>
                  </label>
                </div>
              </div>
              <div style="margin-bottom: 20px">
                <small style="height: 12px; opacity: 50%"
                  >(only for emergency cases)</small
                >
              </div>
              <el-form :model="caseInformation">
                <el-row :gutter="15">
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Case Type
                          <span class="star">*</span>
                        </label>
                        <el-select
                          multiple
                          filterable
                          v-model="caseInformation.case_types"
                          placeholder="Select Case type"
                          :multiple-limit="getCaseTypeLimit"
                          @change="addSpecimenCaseTypes"
                          :disabled="isDisabled || this.$route.params.case_id"
                        >
                          <el-option
                            v-for="(caseType, index) of getCaseTypes"
                            :key="index"
                            :value="caseType.value"
                            :label="caseType.case_name"
                          ></el-option>
                        </el-select>
                        <p class="err error-break">
                          <FormError errorName="case_types"></FormError>
                        </p>

                        <div
                          class="case-select-types"
                          :class="{
                            'active-case-type-error': isError,
                          }"
                        >
                          <p
                            class="selected-case-types"
                            v-for="(
                              caseTypeVal, index
                            ) in caseInformation.case_types"
                            :key="index"
                          >
                            {{ caseTypeMap[caseTypeVal] || caseTypeVal }}
                          </p>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Laboratory
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Laboratory"
                          v-model="caseInformation.lab"
                          :disabled="this.$route.params.case_id || !checkLab"
                        >
                          <el-option
                            v-for="(lab, index) of getAllLabs"
                            :key="index"
                            :value="lab._id"
                            :label="lab.name"
                          ></el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="lab"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Collection Date & Time
                          <span class="star">*</span>
                        </label>
                        <el-date-picker
                          type="datetime"
                          v-model="caseInformation.collection_date"
                          placeholder="MM-DD-YYYY HH:MM AM"
                          format="MM-DD-YYYY hh:mm A"
                          :disabled-date="disabledDate"
                          :default-time="defaultTime"
                          :disabled="isDisabled || isMedicalGroupCase"
                        ></el-date-picker>
                        <p class="err">
                          <FormError errorName="collection_date"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Received Date & Time
                          <span class="star">*</span>
                        </label>
                        <el-date-picker
                          type="datetime"
                          v-model="caseInformation.received_date"
                          placeholder="MM-DD-YYYY HH:MM AM"
                          format="MM-DD-YYYY hh:mm A"
                          :disabled-date="disabledDate"
                          :default-time="defaultTime"
                          :disabled="isDisabled || isMedicalGroupCase"
                        ></el-date-picker>
                        <p class="err error-break">
                          <FormError errorName="received_date"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Ordering Facility
                          <span class="star">*</span>
                        </label>
                        <el-select
                          v-model="caseInformation.hospital"
                          placeholder="Select Ordering Facility"
                          @change="fetchAllPhysiciansByHospital"
                          default-first-option
                          :reserve-keyword="false"
                          clearable
                          filterable
                          @focus="fetchData"
                          :loading="hospitalLoading"
                          :disabled="isDisabled"
                        >
                          <el-option
                            v-for="(hospital, index) of hospitalsData.data"
                            :key="index"
                            :value="hospital._id"
                            :label="hospital.name"
                            :disabled="isInactiveStatus(hospital)"
                          >
                            <span style="float: left">{{
                              hospital.name + "-" + (hospital.state || "")
                            }}</span>
                            <span
                              v-if="isInactiveStatus(hospital)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 10px;
                              "
                              >Inactive</span
                            >
                          </el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="hospital"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Ordering Facility Branch</label>
                        <el-select
                          placeholder="Select Ordering Facility Branch"
                          @change="fetchAllPhysiciansByHospitalBranch"
                          v-model="caseInformation.hospital_branch"
                          default-first-option
                          :reserve-keyword="false"
                          clearable
                          filterable
                          :disabled="isDisabled"
                        >
                          <el-option
                            v-for="(hospital, index) of hospitalBranches"
                            :key="index"
                            :value="hospital._id"
                            :label="hospital.display_name"
                            :disabled="isInactiveStatus(hospital)"
                          >
                            <span style="float: left">
                              {{ hospital.display_name }}
                            </span>
                            <span
                              v-if="isInactiveStatus(hospital)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 10px;
                              "
                              >Inactive</span
                            >
                          </el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="facility_branch"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Ordering Physician
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Ordering Physician"
                          v-model="caseInformation.ordering_physician"
                          clearable
                          filterable
                          default-first-option
                        >
                          <el-option
                            v-for="physician in physiciansData.data"
                            :key="physician._id"
                            :label="physician.name"
                            :value="physician._id"
                            :disabled="isInactiveStatus(physician)"
                          >
                            <span style="float: left">
                              {{ physician.name }}
                            </span>
                            <span
                              v-if="isInactiveStatus(physician)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 15px;
                              "
                              >Inactive</span
                            >
                          </el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="ordering_physician"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Referring Physician</label>
                        <el-select
                          v-model="caseInformation.referring_physician"
                          placeholder="Select Referring Physician"
                          clearable
                          filterable
                          default-first-option
                          :reserve-keyword="false"
                          @focus="fetchRefferingPhysicians"
                          :loading="physicianLoading"
                          :disabled="isDisabled"
                        >
                          <el-option
                            v-for="physician in allReferringPhysicians"
                            :key="physician._id"
                            :label="physician.name"
                            :value="physician._id"
                          ></el-option>
                        </el-select>
                        <p class="err">
                          <FormError
                            errorName="referring_physician"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Bill To
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Bill To"
                          clearable
                          v-model="caseInformation.billing_type"
                          filterable
                          default-first-option
                          :reserve-keyword="false"
                          :disabled="isReleasePending || isFinalizedAmendmentCase(getCaseInformation)"
                        >
                          <el-option
                            class="referring-physician-options"
                            label="INSURANCE"
                            value="INSURANCE"
                          ></el-option>
                          <el-option
                            label="PATIENT"
                            value="PATIENT"
                          ></el-option>
                          <el-option label="CLIENT" value="CLIENT"></el-option>
                          <el-option
                            label="LABCORP"
                            value="LABCORP"
                          ></el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="billing_type"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Order Id</label>
                        <el-input
                          type="text"
                          placeholder="Enter Order Id"
                          v-model="caseInformation.order_id"
                          :rows="3"
                          :disabled="this.$route.params.case_id"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="order_id"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Specimen Collector</label>
                        <el-input
                          placeholder="Enter Specimen Collector"
                          v-model="caseInformation.specimen_collector"
                          :disabled="isDisabled"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="specimen_collector"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="12" :lg="20">
                    <div class="case-creation__input">
                      <el-form-item>
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            column-gap: 2rem;
                          "
                        >
                          <label for="text">
                            ICD-10 ( Indicative )
                            <span class="star">*</span>
                          </label>
                          <el-checkbox
                            class="el-checkbox-icd"
                            style="
                              display: flex;
                              align-items: center;
                              height: 14px;
                            "
                            v-model="includeAllICDCodes"
                            >Include All ICD Codes</el-checkbox
                          >
                        </div>

                        <div class="ten-icd-group d-flex">
                          <div
                            class="each-input mr-5"
                            v-for="(
                              icdCode, index
                            ) of caseInformation.icd_10_codesForm"
                            :key="index"
                          >
                            <el-autocomplete
                              placeholder="CODE"
                              v-model="icdCode.value"
                              popper-class="ten-icd-popper"
                              :fetch-suggestions="getAutoCompleteICDData"
                              @select="selectICDCode($event, icdCode)"
                              :disabled="isFinalizedAmendmentCase(getCaseInformation) && isBillingUser"
                            >
                              <template #default="{ item }">
                                <div class="icd-dropdown-style">
                                  <span class="code pr-5">{{ item.code }}</span>
                                  <span class="desc pl-5">{{
                                    item.description
                                  }}</span>
                                </div>
                              </template>
                            </el-autocomplete>
                          </div>
                        </div>
                        <p class="err">
                          <FormError errorName="icd_10_codes"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="24" :lg="24" v-if="!isBillingUser">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"> CPT Codes </label>

                        <div class="ten-icd-group d-flex">
                          <div
                            class="each-input mr-5"
                            v-for="(
                              cptCode, index
                            ) of caseInformation.cpt_codesForm"
                            :key="index"
                          >
                            <el-autocomplete
                              placeholder="CODE"
                              v-model="cptCode.value"
                              popper-class="ten-icd-popper"
                              :fetch-suggestions="getAutoCompleteCPTData"
                              @select="selectCPTCode($event, cptCode)"
                              :disabled="isFinalizedAmendmentCase(getCaseInformation) && isBillingUser"
                            >
                              <template #default="{ item }">
                                <div class="icd-dropdown-style">
                                  <span>{{ item.code }}</span>
                                </div>
                              </template>
                            </el-autocomplete>
                          </div>
                        </div>
                        <p class="err">
                          <FormError errorName="cpt_codes"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col
                    :xl="8"
                    :lg="8"
                    :md="3"
                    :sm="6"
                    :xs="6"
                    v-if="
                      caseInformation.case_types &&
                      caseInformation.case_types.length
                    "
                  >
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Specimen Types
                          <span class="star">*</span>
                        </label>

                        <div
                          class="specimen-case-type"
                          v-for="(type, index) in this.caseInformation
                            .sample_types"
                          :key="index"
                        >
                          <span class="case-name">
                            {{ caseTypeMap[type.case_type] }}
                          </span>
                          <span class="custom-select-capitalize">
                            <el-select
                              v-model="type.sample_types"
                              multiple
                              filterable
                              allow-create
                              collapse-tags
                              :reserve-keyword="false"
                              default-first-option
                              popper-class="custom-select-dropdown"
                              :disabled="isDisabled || isFinalizedAmendmentCase(getCaseInformation)"
                            >
                              <el-option
                                v-for="(specimen, index) in getSpecimenTypes[
                                  type.case_type
                                ]"
                                :key="index"
                                :label="specimen"
                                :value="specimen"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                :errorName="`sample_types.${index}.sample_types`"
                              ></FormError>
                            </p>
                          </span>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col
                    :xl="3"
                    :lg="4"
                    :md="8"
                    :sm="12"
                    :xs="12"
                    v-if="
                      this.caseInformation.sample_types &&
                      this.caseInformation.sample_types.some(
                        (item) => item.case_type === 'WOUND'
                      )
                    "
                  >
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"
                          >Specimen Location
                          <span class="star">*</span>
                        </label>
                        <el-input
                          placeholder="Enter Specimen Source"
                          v-model="caseInformation.specimen_source"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="specimen_source"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Additional Fax Receiver</label>
                        <el-input
                          placeholder="Enter Additional Fax Receiver"
                          v-model="caseInformation.additional_fax_requisite"
                          :disabled="isDisabled || isFinalizedAmendmentCase(getCaseInformation)"
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="additional_fax_requisite"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="16" :lg="12" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <div class="additonal-fax">
                          <div>
                            <label for="text">Additional Fax</label>
                            <el-input
                              maxlength="10"
                              v-model="faxInputValue"
                              placeholder="Enter Additional Fax "
                              class="el-input"
                              @keyup.enter.prevent="handleInputConfirm"
                              :disabled="isDisabled || isFinalizedAmendmentCase(getCaseInformation)"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="additional_fax"></FormError>
                            </p>
                          </div>
                          <div class="fax-btn">
                            <el-button
                              @click="handleInputConfirm"
                              :disabled="isDisabled || isFinalizedAmendmentCase(getCaseInformation)"
                            >
                              <span>+ Add Fax</span>
                            </el-button>
                            <div
                              class="fax-actions-view"
                              :class="{ 'active-fax-type-error': isError }"
                            >
                              <el-tag
                                class="mr-10"
                                v-for="tag in caseInformation.additional_fax"
                                :key="tag"
                                :disable-transitions="false"
                              >
                                <span class="btn-close-icon">
                                  {{ tag }}
                                  <img
                                    @click="handleFaxRemove(tag)"
                                    src="@/assets/images/fax-tag-close.svg"
                                    alt="icon"
                                  />
                                </span>
                              </el-tag>
                            </div>
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <span class="case-creation__divider"></span>
      <!-- ! Test Information || Case Creation -->
      <div class="case-creation__step case-creation__test-information">
        <div class="case-creation__card">
          <div class="text-information-card">
            <div class="case-creation__heading border-bottom-none">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-test-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Test Information</h3>
              </div>
            </div>
            <div class="test-information-header" >
              <p>You can manage tests here, please add to start</p>
              <div>
                <el-button
                  type="text"
                  class="btn radius-button add-test-btn"
                  @click="popupScreen"
                  :disabled="isFinalizedAmendmentCase(getCaseInformation) || !isBillingUser"
                >
                  <span>
                    <img
                      src="@/assets/images/icons/cases/add-test.svg"
                      alt="tests-icon"
                    />
                  </span>
                  ADD TESTS
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="center-error-message" v-if="isTestInfoError">
          <p class="err">
            <FormError errorName="tests_info"></FormError>
          </p>
        </div>
      </div>
      <div
        class="selected-tests-information"
        v-if="
          (panelsTestsData.selectedCategories &&
            panelsTestsData.selectedCategories.length > 0) ||
          (panelsTestsData.selectedGroup &&
            panelsTestsData.selectedGroup.length > 0 &&
            !addtestModelPopup &&
            !hideTestsDetails)
        "
      >
        <div class="each-test-information">
          <el-checkbox-group
            v-model="panelsTestsData.selectedCategories"
            class="case-vue-tabs vue-tabs"
          >
            <el-tabs v-if="!addtestModelPopup">
              <el-tab-pane
                v-for="(test, index) of getSelectedCaseTypes()"
                :key="index"
                :class="test"
              >
                <template #label>
                  <h3 class="selected-test-title">
                    {{ caseTypeMap[test.case_type_code] }}
                  </h3>
                </template>
                <div v-if="test.case_type_code == 'TOXICOLOGY'">
                  <ToxicologyTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></ToxicologyTestsPreview>
                </div>
                <div v-else-if="test.case_type_code == 'WOUND'">
                  <WoundPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></WoundPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'UTI'">
                  <UTIPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></UTIPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'URINE_CULTURE'">
                  <UrineCulturePanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></UrineCulturePanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'ENT'">
                  <EntPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></EntPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'NAIL'">
                  <NailPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></NailPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'GASTRO'">
                  <GastroPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></GastroPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'CLINICAL_CHEMISTRY'">
                  <BloodPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></BloodPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'STI'">
                  <GTIWomensHealthTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></GTIWomensHealthTests>
                </div>
                <div v-else-if="test.case_type_code == 'URINALYSIS'">
                  <UrinalysisTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></UrinalysisTestsPreview>
                </div>
                <div
                  v-else-if="
                    test.case_type_code == 'RESPIRATORY_PATHOGEN_PANEL'
                  "
                >
                  <RespiratoryTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></RespiratoryTestsPreview>
                </div>
                <div v-else-if="test.case_type_code == 'WOMENS_HEALTH'">
                  <WomensHealthSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></WomensHealthSelectedTests>
                </div>
                <div v-else>
                  <DefaultPanelSelectedTests
                    v-if="show"
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :testType="test"
                    :allSelectedTests="allTests"
                    :caseType="test.case_type_code"
                    @refresh-test-tubes="refreshTestTubeInfo"
                  ></DefaultPanelSelectedTests>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-checkbox-group>
        </div>
      </div>
      <div class="case-creation__add-test" v-if="addtestModelPopup">
        <div class="add-test-popup">
          <el-dialog
            width="90%"
            v-model="addtestModelPopup"
            :destroy-on-close="true"
          >
            <AddTests
              :panelsTestsDataUnchanged="panelsTestsData"
              :caseTypes="caseInformation.case_types"
              @addTestsData="updateTestsPanelsData"
              :selectedChecklist="toxicology_ereq_form"
              :selectedSample="selectedSpecimen"
              v-if="addtestModelPopup"
            ></AddTests>
          </el-dialog>
        </div>
      </div>
      <span class="case-creation__divider"></span>
      <!-- ! Medications Information || Case Creation -->
      <div class="case-creation__step case-creation__test-information">
        <MedicationsAdd
          v-if="showMedication"
          :newCase="checkCaseValidation"
          ref="medicationFormDetails"
          :medicationsData="medicationsList"
          :disabled="isFinalizedAmendmentCase(getCaseInformation) || !isBillingUser"
        ></MedicationsAdd>
        <div class="center-error-message" v-if="isMedicationError">
          <p class="err">
            <FormError errorName="medication"></FormError>
          </p>
        </div>
      </div>
      <!-- TestTube Component Start Here -->

      <NewCaseTestTubeInfo
        :case-type="caseInformation.case_types"
        @tube-data-information="handleTubeData"
        :disabled="isFinalizedAmendmentCase(getCaseInformation)"
      />
      <!-- ! Billing Information || Case Creation -->
      <div
        class="case-creation__step case-creation__billing-information"
        v-if="['INSURANCE'].includes(caseInformation.billing_type)"
      >
        <div class="case-creation__card">
          <div class="case-creation__heading justify-start">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-billing-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Billing Information</h3>
            </div>
            <div class="billing_alignmens">
              <p class="err">
                <FormError errorName="billing_info"></FormError>
              </p>
            </div>
          </div>
          <div class="case-creation__billing-information__body">
            <div class="case-creation__tabs billing-information-tabs">
              <el-tabs v-model="activeName" @tab-click="updateSelectedTabQuery">
                <el-tab-pane name="first">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasError }"
                      >primary insurance</span
                    >
                  </template>
                  <PrimaryInsurance
                    v-if="activeName === 'first' && showInsuranceDob"
                    :primaryInsurance="primaryInsuranceForm"
                    :refreshDob="refreshPatientDob"
                    :parentRefs="$refs"
                    :state="selectedHospitalState"
                    :physicianPecos="pecosStatus"
                    :orderingPhysician="caseInformation.ordering_physician"
                    :billTo="caseInformation.billing_type"
                    ref="primaryInsuranceForm"
                    :disabled="isFinalizedAmendmentCase(getCaseInformation) && isBillingUser"
                  ></PrimaryInsurance>
                </el-tab-pane>
                <el-tab-pane name="second">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasSecondaryErrors }"
                      >Secondary Insurance</span
                    >
                  </template>
                  <SecondaryInsurance
                    v-if="activeName === 'second' && showInsuranceDob"
                    :secondaryInsurance="secondaryInsuranceForm"
                    ref="secondaryInsuranceForm"
                    :parentRefs="$refs"
                    :state="selectedHospitalState"
                    :refreshDob="true"
                    :billTo="caseInformation.billing_type"
                    :disabled="isFinalizedAmendmentCase(getCaseInformation) && isBillingUser"
                  ></SecondaryInsurance>
                </el-tab-pane>
                <el-tab-pane name="third">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasTertiaryErrors }"
                      >Tertiary Insurance</span
                    >
                  </template>

                  <TertiaryInsuranceForm
                    v-if="activeName === 'third' && showInsuranceDob"
                    :tertiaryInsurance="tertiaryInsuranceForm"
                    ref="tertiaryInsuranceForm"
                    :state="selectedHospitalState"
                    :parentRefs="$refs"
                    :refreshDob="true"
                    :billTo="caseInformation.billing_type"
                    :disabled="isFinalizedAmendmentCase(getCaseInformation) && isBillingUser"
                  ></TertiaryInsuranceForm>
                </el-tab-pane>
                <el-tab-pane name="fourth">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasGuarantorErrors }"
                      >Guarantor</span
                    >
                  </template>

                  <GuarantorInsurance
                    v-if="activeName === 'fourth' && showInsuranceDob"
                    :guarantorInsurance="guarantorInsuranceForm"
                    :state="selectedHospitalState"
                    ref="guarantorInsuranceForm"
                    :parentRefs="$refs"
                    :disabled="isFinalizedAmendmentCase(getCaseInformation) && isBillingUser"
                  ></GuarantorInsurance>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <div
        class="center-error-message pt-10 pb-20"
        v-if="this.getErrors && this.getErrors.critical_error"
      >
        <p class="err">
          <FormError errorName="critical_error"></FormError>
        </p>
      </div>

      <div class="action-buttons-space"></div>
      <!-- ! Action Buttons || Case Creation -->
      <div class="case-creation__actions fixed">
        <ul class="list">
          <li>
            <el-button
              type="button"
              class="btn cancel-button"
              @click="goToAllCases"
              >Cancel</el-button
            >
          </li>
          <li>
            <el-button
              type="button"
              class="btn save-button"
              @click="createNewCase"
              >Save</el-button
            >
          </li>
        </ul>
      </div>
    </div>
    <!-- External Components -->
    <ExistingCaseDetails
      v-if="errorDiloag"
      :existedCase="existedCaseDetails"
      :validationErrorMsg="validationError"
      :caseType="caseInformation.case_types"
      :caseInformation="caseInformationDetails"
      :caseUpdate="caseUpdate"
      :newCase="newCase"
      v-on:closeDialog="handleClose"
      v-on:closePopupDialog="handlePopUp"
      @newCaseCreation="newCaseCreation"
      @approveCase="approveCase"
    ></ExistingCaseDetails>

    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="updateCase"
    >
    </ResonForChange>
    <div class="default-modal" v-if="medicationPopup">
      <el-dialog top="10%" width="45%" v-model="medicationPopup">
        <div class="dialog-header">
          <span class="header-part"> Missing Tests </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="medicationPopup = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="all-cases-view">
          <div class="popup-date">
            <p class="description">
              Click on the tests associated with the given medications.
            </p>
            <div class="primary-content-view-new" v-loading="loading">
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
              >
                <el-table
                  class="missing-tests-table"
                  :data="this.medicationMappedTestsData"
                >
                  <el-table-column width="170" label="Medication">
                    <template #default="scope">
                      {{ scope.row.medication }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Test Names">
                    <template #default="scope">
                      {{ scope.row.tests }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer export-footer">
          <el-button class="ok-Btn" @click="createCase">OK</el-button>
        </div>
      </el-dialog>
    </div>
    <BillingValidation
      v-if="icdErrorDialog"
      :validationErrors="billingErrors"
      v-on:close="icdErrorDialog = false"
      :caseCreation="true"
      @moveCase="moveCase"
    ></BillingValidation>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import AddTests from "@/components/cases/TestInformation";
import caseConstants from "@/config/constants/caseConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WoundPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const UrineCulturePanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UrineCulturePanelSelectedTests"
  )
);
const EntPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/EntPanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/ToxicologyTestsPreview")
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const NailPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/NailPanelSelectedTests"
  )
);
const GastroPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GastroPanelSelectedTests"
  )
);
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);

import { startLoading } from "@/helpers/loadingHelper";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);
const BillingValidation = defineAsyncComponent(() =>
  import("@/components/cases/BillingValidation")
);
// billing Info
import PrimaryInsurance from "@/components/cases/billingInfo/forms/PrimaryInsurance";
import SecondaryInsurance from "@/components/cases/billingInfo/forms/SecondaryInsurance";
import TertiaryInsuranceForm from "@/components/cases/billingInfo/forms/TertiaryInsurance";
import GuarantorInsurance from "@/components/cases/billingInfo/forms/GuarantorInsurance";
import PatientInformation from "@/components/cases/PatientInformationAdd";
import MedicationsAdd from "@/components/cases/MedicationsAdd";
import InsuranceHelper from "@/mixins/InsuranceHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const GTIWomensHealthTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GTIWomensHealthTests"
  )
);
const UrinalysisTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/UrinalysisTestsPreview")
);
import { ElMessageBox } from "element-plus";
import NewCaseTestTubeInfo from "./NewCaseTestTubeInfo.vue";
const RespiratoryTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/RespiratoryTestsPreview")
);
const WomensHealthSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WomensHealthSelectedTests"
  )
);
export default {
  components: {
    AddTests,
    ExistingCaseDetails,
    ResonForChange,
    FormError,
    WoundPanelSelectedTests,
    UTIPanelSelectedTests,
    UrineCulturePanelSelectedTests,
    EntPanelSelectedTests,
    ToxicologyTestsPreview,
    BloodPanelSelectedTests,
    DefaultPanelSelectedTests,
    PrimaryInsurance,
    SecondaryInsurance,
    TertiaryInsuranceForm,
    GuarantorInsurance,
    NailPanelSelectedTests,
    PatientInformation,
    MedicationsAdd,
    GastroPanelSelectedTests,
    GTIWomensHealthTests,
    UrinalysisTestsPreview,
    BillingValidation,
    RespiratoryTestsPreview,
    NewCaseTestTubeInfo,
    WomensHealthSelectedTests,
  },
  mixins: [caseDataHelper, AppHelper, InsuranceHelper, UserPermissionsHelper],
  data() {
    return {
      page: 1,
      pageSize: 10,
      errorDiloag: false,
      caseUpdate: false,
      newCase: false,
      refreshPatientDob: true,
      existedCaseDetails: {},
      validationError: "",
      caseInformationDetails: {},
      takeReasonDialog: false,
      loading: false,
      hideTestsDetails: false,
      addtestModelPopup: false,
      modalLoading: false,
      activeName: "first",
      filteredPanels: [],
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      getSpecimenTypes: { ...caseConstants.CASE_TYPE_SPECIMEN_TYPE_MAP },
      faxInputValue: "",
      defaultTime: [new Date()],
      //case information
      caseInformation: {
        case_types: [],
        lab: "",
        collection_date: "",
        specimen_collector: "",
        specimen_source: "",
        received_date: "",
        hospital: "",
        hospital_branch: "",
        ordering_physician: "",
        referring_physician: null,
        additional_fax_requisite: "",
        icd_10_codes: "",
        billing_type: "",
        order_id: "",
        is_stat: false,
        additional_fax: [],
        icd_10_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
        ],
        sample_types: "",
        cpt_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
          {
            sno: 11,
            value: "",
          },
          {
            sno: 12,
            value: "",
          },
          {
            sno: 13,
            value: "",
          },
          {
            sno: 14,
            value: "",
          },
          {
            sno: 15,
            value: "",
          },
          {
            sno: 16,
            value: "",
          },
          {
            sno: 17,
            value: "",
          },
          {
            sno: 18,
            value: "",
          },
          {
            sno: 19,
            value: "",
          },
          {
            sno: 20,
            value: "",
          },
        ],
        cpt_codes: "",
      },
      searchHospital: "",
      search_case_types: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
        selectedTestsDetails: [],
      },
      selectedTab: null,
      hospitalBranches: [],
      physiciansData: {},
      allReferringPhysicians: [],
      show: false,
      showDob: false,
      showInsuranceDob: false,
      showMedication: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      allTests: [],
      caseId: "",
      primaryInsuranceForm: {},
      secondaryInsuranceForm: {},
      tertiaryInsuranceForm: {},
      guarantorInsuranceForm: {},
      patientInformation: {},
      physicianOptions: [],
      hospitalsData: {},
      hospitalLoading: false,
      physicianLoading: false,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      sampleTypesList: "",
      selectedSampleTypes: "",
      selectedSampleTypes1: "",
      selectedSampleTypes2: "",
      sample_types: [],
      labdaqFacilityData: {},
      units: "",
      medicationsList: [],
      toxicology_ereq_form: [],
      options: caseConstants.TOX_CHECK_LIST,
      selectedSpecimen: "",
      medicationMappedTestsData: [],
      medicationPopup: false,
      addMedicationTests: false,
      medicationMismatchedData: [],
      icdErrorDialog: false,
      billingErrors: [],
      insurancePopup: false,
      foundCoverages: [],
      errorMessage: "",
      pecosStatus: null,
      selectedHospitalState: null,
      includeAllICDCodes: false,
      caseIdToInsurance: "",
      selectedTubeData: [],
    };
  },
  computed: {
    checkCaseValidation() {
      if (this.$route.params.case_id) {
        return false;
      }
      return true;
    },
    ...mapGetters("cases", [
      "getCaseCreationStatus",
      "getCaseInformation",
      "getCaseInformationValidationErrorsCode",
      "getCaseInformationSaveStatus",
      "getMedicationTests",
      "getSingleCaseTestsInfo",
    ]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes", "getAllCptCodes"]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserPrimaryLabId",
      "getUserAllowedLabs",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", [
      "getAllPhysicians",
    ]),
    ...mapGetters("branches", ["getAllBranches"]),
    getCaseTypeLimit() {
      return 1;
    },
    isTestInfoError() {
      if (this.getErrors && this.getErrors.tests_info) {
        return true;
      }
      return false;
    },
    isMedicationError() {
      if (this.getErrors && this.getErrors.medication) {
        return true;
      }
      return false;
    },
    getCaseTypes() {
      return this.search_case_types;
    },
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    hasError() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.primary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasSecondaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.secondary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasTertiaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.tertiary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasGuarantorErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf("billing_info.insurance.guarantor") !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    isError() {
      if (this.getErrors && this.getErrors.collection_date) {
        return true;
      } else if (this.getErrors && this.getErrors.received_date) {
        return true;
      } else if (this.getErrors && this.getErrors.additional_fax) {
        return true;
      } else if (
        this.getErrors &&
        this.getErrors.billing_info &&
        this.getErrors.billing_info.insurance &&
        this.getErrors.billing_info.insurance.primary_insurance
      ) {
        return true;
      } else if (
        this.getErrors &&
        this.getErrors.billing_info &&
        this.getErrors.billing_info.insurance &&
        this.getErrors.billing_info.insurance.secondary_insurance
      ) {
        return true;
      }
      if (
        this.getCaseInformationValidationErrorsCode &&
        this.getCaseInformationValidationErrorsCode.error_code ==
          "GENETIC_VALIDATE"
      ) {
        return true;
      }
      return false;
    },
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code == "DLW") {
          return true;
        }
        return false;
      }
      return false;
    },
    isDisabled() {
      return !this.isBillingUser || this.isReleasePending;
    },
    isMedicalGroupCase() {
      const caseData = this.getCaseInformation;
      return !!(
        caseData &&
        caseData.testgo_order_type === "MEDICAL-GROUP" &&
        caseData.is_commercial_created &&
        caseData.medical_group_accession_id
      );
    },
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupWiseTestsData",
      "getNewLabGroupPanelTests",
    ]),
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.loadInitData();
    await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
      lab_id: this.getUserPrimaryLabId,
    });
  },
  methods: {
    handleTubeData(data) {
      this.selectedTubeData = data;
    },
    async createCase() {
      this.addMedicationTests = true;
      this.medicationPopup = false;
      if (this.getNewLabGroupPanelTests) {
        let panelTestPairs = this.medicationMappedTestsData.flatMap((entry) => {
          let panelCodes =
            typeof entry.panel_codes === "string"
              ? entry.panel_codes.split(",").map((s) => s.trim())
              : Array.isArray(entry.panel_codes)
              ? entry.panel_codes
              : [];

          let testNames =
            typeof entry.tests === "string"
              ? entry.tests.split(",").map((s) => s.trim())
              : Array.isArray(entry.tests)
              ? entry.tests
              : [];

          return panelCodes.flatMap((panel) =>
            testNames.map((test) => ({
              panel_code: panel,
              test_name: test,
            }))
          );
        });

        // Filter getNewLabGroupPanelTests by checking both panel_code and test_name match
        let PanelCodesFromLabTests = this.getNewLabGroupPanelTests.filter(
          (testObj) =>
            panelTestPairs.some(
              (pair) =>
                pair.panel_code === testObj.panel_code &&
                pair.test_name === testObj.test_name
            )
        );

        let groupedPanels = {};

        PanelCodesFromLabTests.forEach((item) => {
          const key = item.panel_id;

          if (!groupedPanels[key]) {
            groupedPanels[key] = {
              case_type_code: item.case_type_code,
              panel_code: item.panel_code,
              panel_id: item.panel_id,
              test_ids: [],
            };
          }

          groupedPanels[key].test_ids.push(item._id);
        });
        this.filteredPanels = Object.values(groupedPanels);
      }
      const caseId = this.$route.params.case_id;
      if (caseId) {
        await this.askReason();
      } else {
        this.addCase();
      }
    },
    updatePatientData(data) {
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.primary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.primary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.secondary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.secondary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.tertiary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.tertiary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.guarantor
      ) {
        this.showInsuranceDob = false;
        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.guarantorInsuranceForm = data.billing_info.insurance.guarantor;
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.medication &&
        data.medication.length != 0
      ) {
        this.showMedication = false;
        setTimeout(() => {
          this.showMedication = true;
        }, 100);
        this.medicationsList = data.medication;
      } else {
        this.showMedication = false;
        setTimeout(() => {
          this.showMedication = true;
        }, 100);
        this.medicationsList = [];
      }
    },
    manageCaseTypes() {
      this.search_case_types = this.getLabBasedCaseTypes(
        caseConstants.CASE_TYPES_DATA
      );
    },
    addSpecimenCaseTypes() {
      this.manageCaseTypes();
      if (!this.caseInformation.sample_types) {
        this.caseInformation.sample_types = [];
      }
      if (this.caseInformation && this.caseInformation.case_types.length == 0) {
        this.caseInformation.sample_types = [];
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length
      ) {
        this.caseInformation.case_types.forEach((singleCaseType) => {
          let caseSampleTypeExisted = this.caseInformation.sample_types.find(
            (e) => e.case_type == singleCaseType
          );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              // sample_types: [],
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [], // we are to add default case type here
            };
            this.caseInformation.sample_types.push(caseTypeDefaultSampleName);
          }
        });

        // we need to remove not existed

        this.caseInformation.sample_types =
          this.caseInformation.sample_types.filter((sampleTypeData) =>
            this.caseInformation.case_types.includes(sampleTypeData.case_type)
          );
      } else {
        this.caseInformation.sample_types = [];
      }
    },
    async fetchData() {
      this.hospitalLoading = true;
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalLoading = false;
    },
    async fetchRefferingPhysicians() {
      this.physicianLoading = true;
      await this.$store.dispatch("physicians/fetchAllPhysicians", {
        get_all: true,
      });
      this.allReferringPhysicians =
        this.getAllPhysicians &&
        this.getAllPhysicians.data &&
        this.getAllPhysicians.data.length
          ? this.getAllPhysicians.data
          : [];
      this.physicianLoading = false;
    },
    // Method to refresh test tube information when tests are removed
    async refreshTestTubeInfo() {
      try {
        let testIdsArray = [];
        if (
          this.caseInformation?.case_types.some((e) => ["CLINICAL_CHEMISTRY"])
        ) {
          const panelIdsArray = this.getNewLabGroupPanelTests
            .filter(
              (a) =>
                a.panel_code === "ALL_TESTS" || a.panel_code === "SEND_OUTS"
            )
            .map((e) => e.panel_id);

          const panelIds = new Set(panelIdsArray);

          testIdsArray = this.panelsTestsData.selectedCategories
            .filter((e) => panelIds.has(e.panel_id))
            .flatMap((a) => a.test_ids);
        } else {
          testIdsArray = (this.panelsTestsData.selectedCategories || [])
            .filter((item) => item.all_tests !== true)
            .flatMap((item) => item.test_ids || []);
        }
        const sample_types = this.caseInformation.sample_types.flatMap((item) =>
          item.sample_types.map((sample) => ({
            case_type: item.case_type,
            sample_type: sample,
          }))
        );
        const isGroupCase = this.caseInformation?.case_types.some((type) =>
          [
            "UTI",
            "WOUND",
            "NAIL",
            "GASTRO",
            "RESPIRATORY_PATHOGEN_PANEL",
            "URINALYSIS",
            "STI",
            "WOMENS_HEALTH",
            "URINE_CULTURE",
            "ENT"
          ].includes(type)
        );
        const group_ids = isGroupCase
          ? this.panelsTestsData?.selectedGroup?.map(
              (group) => group.group_id
            ) || []
          : [];
        const panel_info = this.panelsTestsData.selectedCategories;
        const panel_ids = panel_info.map((panel) => panel.panel_id);

        // API call for test tubes fetching
        await this.$store.dispatch(
          "labSquireOrderTestTubes/fetchLabSquireOrderTestTubesInfo",
          {
            case_type: this.caseInformation.case_types
              ? Array.isArray(this.caseInformation.case_types)
                ? this.caseInformation.case_types
                : [this.caseInformation.case_types]
              : [],
            test_info: testIdsArray,
            lab_id: this.getUserPrimaryLabId,
            group_info: group_ids,
            panel_info: panel_ids,
            sample_types: sample_types,
          }
        );
      } catch (error) {
        console.error("Error refreshing test tube info:", error);
      }
    },
    async loadInitData() {
      const loading = startLoading();
      try {
        if (this.$route.params.case_id) {
          this.checkCaseInformation();
          this.show = true;
        } else {
          this.loading = false;
          this.caseForm = true;
          // await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        }

        let params = { get_all: true };
        await this.$store.dispatch("help/fetchAllStates");

        await this.$store.dispatch("labs/fetchAllLabs", params);
        this.showDob = true;
        this.showInsuranceDob = true;
        this.showMedication = true;
        await this.getLabCaseTypes();
        this.caseInformation.lab = this.getUserPrimaryLabId;

        loading.close();
      } catch (err) {
        loading.close();
      }
    },
    handleFaxRemove(tag) {
      this.caseInformation.additional_fax.splice(
        this.caseInformation.additional_fax.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      if (!this.faxInputValue) {
        this.$message({
          message: "Additional fax not empty!",
          type: "warning",
        });
      } else {
        let inputValue = this.faxInputValue;
        if (inputValue) {
          this.caseInformation.additional_fax.push(inputValue);
        }
        this.faxInputValue = "";
      }
    },
    parseInsuranceForm(insuranceData) {
      let params = { ...insuranceData };

      // filtering the object
      // removing non entered values
      Object.keys(params).forEach((keyValue) => {
        if (!params[keyValue]) {
          delete params[keyValue];
        }
      });

      return params;
    },
    isObjectUpdated(original, updated) {
      const keys = Object.keys(original);

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (original[key] !== updated[key]) {
          return true; // If any value is updated, return true
        }
      }

      return false; // If no value is updated, return false
    },
    formatDOB(dateString) {
      // Extracting the date part from the ISO date string
      if (!dateString) return "";
      return dateString.split("T")[0];
    },
    upperCasePatientData(patientInfo) {
      // console.log("Original Patient Info:", patientInfo);
      const newPatientInfo = {};

      for (const [key, value] of Object.entries(patientInfo)) {
        if (typeof value === "string") {
          newPatientInfo[key] = value.toUpperCase();
        } else {
          newPatientInfo[key] = value;
        }
      }

      return newPatientInfo;
    },
    prepreDataFromFormData() {
      let patientFormInfo = this.$refs["patientInformationForm"];
      let params = this.parseCaseInfo();
      let patientInfo = patientFormInfo.formatPatientInfo();
      // Below Condition For Report Regeneration 
      if(this.isAmmendedCase){
        patientInfo = this.upperCasePatientData(patientInfo);
      }
      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
        if (this.$route.params.case_id) {
          const newObj = { ...this.primaryInsuranceForm };
          if (
            newObj.hasOwnProperty("date_of_birth") &&
            newObj.date_of_birth !== ""
          ) {
            newObj.date_of_birth = this.formatDOB(
              this.primaryInsuranceForm.date_of_birth
            );
          }

          const isUpdated = this.isObjectUpdated(
            newObj,
            primaryInsuranceFormData
          );
          if (isUpdated) {
            params.allow_recheck_insurance = true;
          }
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        params.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      } else {
        params.billing_info = {};
      }
      params.patient_info = this.getFormattedValues(patientInfo);
      if (this.addMedicationTests) {
        if (Array.isArray(this.filteredPanels)) {
          // Extract all test IDs from filtered panels
          const filteredTestIds = this.filteredPanels.flatMap(
            (panel) => panel.test_ids || []
          );

          // Deduplicate new test IDs
          const uniqueFilteredTestIds = [...new Set(filteredTestIds)];

          // Derive current selected test IDs from selectedCategories
          const selectedTestIds =
            this.panelsTestsData.selectedCategories.flatMap(
              (category) => category.test_ids || []
            );

          // Add new test IDs to selectedCategories-derived test list if not already included
          const combinedTestIds = [...selectedTestIds];

          uniqueFilteredTestIds.forEach((id) => {
            if (!combinedTestIds.includes(id)) {
              combinedTestIds.push(id);
            }
          });

          // Final deduplication and assignment
          const allUniqueTestIds = [...new Set(combinedTestIds)];
          params.tests_info = allUniqueTestIds;
        } else {
          console.error(
            "this.filteredPanels is not an array or is undefined/null."
          );
        }
      } else {
        params.tests_info = this.panelsTestsData.selectedCategories
          .map((e) => e.test_ids)
          .flat();
      }
      if (this.caseInformation && this.caseInformation.case_types) {
        params.test_tube_information = this.selectedTubeData.map((tube) => ({
          tube_id: tube.tube_id,
          tube_name: tube.tube_name,
          image_url: tube.image_url,
          status: tube.status,
          collected_tests: tube.selected_tests,
        }));
      } else {
        params.test_tube_information = [];
      }

      params.coriell_test_panels = this.panelsTestsData.selectedCoriellPanels;
      let medicationFormDetails = this.$refs["medicationFormDetails"];
      if (medicationFormDetails) {
        params.medication = medicationFormDetails.getMedicationsList();
      }
      if (
        this.caseInformation &&
        this.caseInformation.cpt_codesForm &&
        this.caseInformation.cpt_codesForm.length
      ) {
        params.cpt_codes = this.caseInformation.cpt_codesForm
          .filter((e) => e.value)
          .map((e) => e.value);
      } else {
        params.cpt_codes = [];
      }
      if (
        this.toxicology_ereq_form &&
        this.toxicology_ereq_form.length
      ) {
        params.toxicology_ereq_form = this.toxicology_ereq_form;
      } else {
        params.toxicology_ereq_form = [];
      }

      if (
        this.caseInformation.case_types?.some((type) =>
          [
            "UTI",
            "WOUND",
            "NAIL",
            "GASTRO",
            "RESPIRATORY_PATHOGEN_PANEL",
            "URINALYSIS",
            "STI",
            "WOMENS_HEALTH",
            "URINE_CULTURE",
            "ENT"
          ].includes(type)
        )
      ) {
        params.groups = this.panelsTestsData.selectedGroup;
      }

      if (this.filteredPanels && this.filteredPanels.length) {
        params.panels = [
          ...this.panelsTestsData.selectedCategories,
          ...this.filteredPanels,
        ];
      } else {
        params.panels = this.panelsTestsData.selectedCategories;
      }

      return params;
    },
    parseCaseInfo() {
      return {
        case_types: this.caseInformation.case_types,
        lab: this.caseInformation.lab,
        collection_date: this.convertToLabUTC(
          this.caseInformation.collection_date
        ),
        received_date: this.convertToLabUTC(this.caseInformation.received_date),
        hospital: this.caseInformation.hospital,
        icd_10_codes: this.caseInformation.icd_10_codesForm
          .filter((e) => e.value)
          .map((e) => e.value),
        ordering_physician: this.caseInformation.ordering_physician,
        referring_physician: this.caseInformation.referring_physician || null,
        hospital_branch: this.caseInformation.hospital_branch
          ? this.caseInformation.hospital_branch
          : null,
        billing_type: this.caseInformation.billing_type,
        is_stat: this.caseInformation.is_stat,
        specimen_collector: this.caseInformation.specimen_collector
          ? this.caseInformation.specimen_collector
          : "",
        specimen_source: this.caseInformation.specimen_source,
        additional_fax: this.caseInformation.additional_fax,
        order_id: this.caseInformation.order_id,
        sample_types: this.convertSampleTypesToCapital(
          this.caseInformation.sample_types
        ),
        additional_fax_requisite: this.caseInformation.additional_fax_requisite
          ? this.caseInformation.additional_fax_requisite
          : "",
      };
    },
    convertSampleTypesToCapital(sampleTypes) {
      if (!sampleTypes) return "";
      return sampleTypes.map((s) => {
        s.sample_types = s.sample_types.map((f) => this.changetocaptila(f));
        return s;
      });
    },
    updateSelectedTabQuery() {
      const primaryInfo = this.$refs["primaryInsuranceForm"];
      if (primaryInfo) {
        this.primaryInsuranceForm = this.parseInsuranceForm(
          primaryInfo.getPrimaryInsuranceFormData()
        );
      }
      const secondaryInfo = this.$refs["secondaryInsuranceForm"];
      if (secondaryInfo) {
        this.secondaryInsuranceForm = this.parseInsuranceForm(
          secondaryInfo.getSecondaryInsuranceFormData()
        );
      }
      const teritaryInfo = this.$refs["tertiaryInsuranceForm"];
      if (teritaryInfo) {
        this.tertiaryInsuranceForm = this.parseInsuranceForm(
          teritaryInfo.getTertiaryInsuranceFormData()
        );
      }
      const gaurantorInfo = this.$refs["guarantorInsuranceForm"];
      if (gaurantorInfo) {
        this.guarantorInsuranceForm = this.parseInsuranceForm(
          gaurantorInfo.getGuarantorInsuranceFormData()
        );
      }
    },
    async handleClose(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });

      window.location.reload();
    },
    async handlePopUp(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });
    },
    async newCaseCreation(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      window.location.reload();
    },
    async moveCase(response) {
      try {
        this.errorDiloag = response;
        await this.$store.commit("errors/clear");
        this.loading = true;
        let params = this.prepreDataFromFormData();
        params.billing_acknowledged = true;
        if (this.$route.params.case_id) {
          const caseId = this.$route.params.case_id;
          params.case_id = caseId;
          params.data_update_reason = this.updateReason;
          await this.$store.dispatch("cases/updateCase", params);

          if (this.getCaseInformationSaveStatus) {
            successNotification("Case Updated Successfully");
            if (this.$route.query && this.$route.query.insuranceUpdate) {
              delete this.$route.query.insuranceUpdate;
            }
            this.goBack();
          } else {
            if (!this.getErrors || this.getError) {
              errorNotification("Error while updating Case");
            }
          }
        } else {
          await this.$store.dispatch("cases/addNewCase", params);
          if (this.getCaseCreationStatus) {
            successNotification("New Case Created Successfully");
            this.goBack();
          } else if (this.handleValidationError()) {
            this.billingApprove = true;
          } else {
            if (!this.getErrors || this.getError) {
              errorNotification("Error while creating New Case");
            }
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async approveCase(response) {
      try {
        this.errorDiloag = response;
        await this.$store.commit("errors/clear");
        this.loading = true;
        let params = this.prepreDataFromFormData();
        params.auto_approved = true;
        // if (this.billingApprove) {
        //   params.billing_acknowledged = true;
        // }
        params.billing_acknowledged = true;
        await this.$store.dispatch("cases/addNewCase", params);
        if (this.getCaseCreationStatus) {
          successNotification("New Case Created Successfully");
          if (this.$route.query && this.$route.query.insuranceUpdate) {
            delete this.$route.query.insuranceUpdate;
          }
          this.goBack();
        } else if (this.handleValidationError()) {
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(this.getError || "Error while creating New Case");
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    async createNewCase() {
      let medicationFormDetails = this.$refs["medicationFormDetails"];
      let medications = [];
      if (medicationFormDetails) {
        medications = medicationFormDetails.getMedicationsList();
      }

      const hasToxicology = this.panelsTestsData?.selectedCategories?.some(
        (e) => e?.case_type_code === "TOXICOLOGY"
      );

      if (
        this.toxicology_ereq_form &&
        this.toxicology_ereq_form.length &&
        hasToxicology &&
        medications.length > 0
      ) {
        let params = {
          case_type: "TOXICOLOGY",
          lab: this.getAuthenticatedUser.lab,
          medication: medications,
        };
        await this.$store.dispatch("cases/fetchMedicationBasedTests", params);

        if (this.getMedicationTests && this.getMedicationTests.data) {
          console.log(this.getMedicationTests.data, "getMedicationTests");
          this.medicationMismatchedData = Object.values(
            this.getMedicationTests.data
          ).flatMap((arr) => arr);
          // Flatten the fetched tests into a single array and remove duplicates
          let testSet = new Set();
          let fetchedTests = [];
          let medicationTestsMap = {};

          for (let medication in this.getMedicationTests.data) {
            if (this.getMedicationTests.data.hasOwnProperty(medication)) {
              this.getMedicationTests.data[medication].forEach((test) => {
                if (!testSet.has(test._id)) {
                  testSet.add(test._id);
                  fetchedTests.push(test);
                }
                if (!medicationTestsMap[medication]) {
                  medicationTestsMap[medication] = [];
                }
                medicationTestsMap[medication].push({
                  name: test.name,
                  panel_code: test.panel_code,
                });
              });
            }
          }
          // Convert the medicationTestsMap values to comma-separated strings
          let formattedMedicationTestsMap = [];
          for (let medication in medicationTestsMap) {
            if (medicationTestsMap.hasOwnProperty(medication)) {
              const testNames = medicationTestsMap[medication]
                .map((test) => test.name)
                .join(", ");
              const panelCodes = medicationTestsMap[medication]
                .map((test) => test.panel_code)
                .join(", ");

              formattedMedicationTestsMap.push({
                medication: medication,
                tests: testNames,
                panel_codes: panelCodes,
              });
            }
          }
          let missingTests = fetchedTests.filter(
            (test) => !this.panelsTestsData.selectedTestIds.includes(test._id)
          );
          if (missingTests.length === 0) {
            const caseId = this.$route.params.case_id;
            if (caseId) {
              await this.askReason();
            } else {
              this.addCase();
            }
          } else {
            await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
              get_all: true,
              lab_id: this.caseInformation.lab || this.getUserPrimaryLabId,
              case_type_code: "TOXICOLOGY",
            });

            this.medicationMappedTestsData = formattedMedicationTestsMap;
            this.medicationPopup = true;
          }
        }
      } else {
        const caseId = this.$route.params.case_id;
        if (caseId) {
          await this.askReason();
        } else {
          this.addCase();
        }
      }
    },
    async updateCase(reason) {
      this.updateNewCase(reason);
    },
    async updateNewCase(reason) {
      try {
        this.loading = true;
        let params = this.prepreDataFromFormData();
        const caseId = this.$route.params.case_id;
        params.case_id = caseId;
        params.data_update_reason = reason;

        if (
          this.getCaseInformation &&
          this.getCaseInformation.billing_info &&
          this.caseInformation &&
          this.caseInformation.billing_type == "INSURANCE" &&
          this.getCaseInformation.billing_info.insurance &&
          this.getCaseInformation.billing_info.insurance.primary_insurance
        ) {
          params.billing_info.insurance.primary_insurance.individual_deductible =
            this.getCaseInformation.billing_info.insurance.primary_insurance
              .individual_deductible || "";
          params.billing_info.insurance.primary_insurance.individual_deductible_remaining =
            this.getCaseInformation.billing_info.insurance.primary_insurance
              .individual_deductible_remaining || "";
          params.billing_info.insurance.primary_insurance.insurance_status =
            this.getCaseInformation.billing_info.insurance.primary_insurance
              .insurance_status || "";
          params.billing_info.insurance.primary_insurance.rejection_reason =
            this.getCaseInformation.billing_info.insurance.primary_insurance
              .rejection_reason || "";
          params.billing_info.insurance.primary_insurance.waveland_plan_name =
            this.getCaseInformation.billing_info.insurance.primary_insurance
              .waveland_plan_name || "";
        }

        await this.$store.dispatch("cases/updateCase", params);
        this.caseUpdate = true;
        if (this.getCaseInformationSaveStatus) {
          if (
            this.getCaseInformationSaveStatus &&
            this.getCaseInformation &&
            this.caseInformation &&
            this.caseInformation.billing_type == "INSURANCE"
          ) {
            if (
              params.billing_info &&
              params.billing_info.insurance &&
              params.billing_info.insurance.primary_insurance &&
              params.billing_info.insurance.secondary_insurance &&
              this.$route.query &&
              this.$route.query.insuranceUpdate === "Replaced"
            ) {
              let cpNotes = `The insurance payor ${params.billing_info.insurance.secondary_insurance.payor} has ${params.billing_info.insurance.primary_insurance.payor} as primary insurance for the DOS, so it has been replaced with the insurance payor ${params.billing_info.insurance.primary_insurance.payor}.`;
              let newParams = {
                case_id: caseId,
                billing_status: "Unbilled",
                billing_sub_status: "",
                billing_status_notes: cpNotes,
                billing_notes: "",
                ar_notes: "",
              };
              await this.$store.dispatch(
                "cases/updateBillingCategory",
                newParams
              );
            }
            if (this.$route.query && this.$route.query.insuranceUpdate) {
              delete this.$route.query.insuranceUpdate;
            }
          }
          successNotification("Case Updated Successfully");
          this.goBack();
        } else if (this.handleValidationError()) {
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(this.getError || "Error while updating Case");
          }
        }
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    handleValidationError() {
      let errorCode =
        this.getCaseInformationValidationErrorsCode &&
        this.getCaseInformationValidationErrorsCode.error_code;
      // Handle common validation errors
      if (
        errorCode === "GENETIC_TEST_EXISTED" ||
        errorCode === "TEST_ALREADY_EXISTED" ||
        errorCode === "DUPLICATE_EXISTED" ||
        errorCode === "NON_GENTIC_TEST_VALIDATE"
      ) {
        this.errorDiloag = true;
        this.validationError = errorCode;

        if (
          this.getCaseInformationValidationErrorsCode &&
          this.getCaseInformationValidationErrorsCode.errors &&
          this.getCaseInformationValidationErrorsCode.errors.existed_details
        ) {
          this.existedCaseDetails =
            this.getCaseInformationValidationErrorsCode.errors.existed_details;
        }

        this.caseInformationDetails = this.prepreDataFromFormData();
        return true;
      }
      // Handle billing validation errors
      if (errorCode === "BILLING_VALIDATION_ERRORS") {
        this.icdErrorDialog = true;
        this.billingErrors = this.getCaseInformationValidationErrorsCode.errors;
        return true;
      }
      return false;
    },
    async addCase() {
      let params = this.prepreDataFromFormData();
      if (
        params.billing_info?.insurance?.primary_insurance?.payor &&
        this.caseInformation.ordering_physician &&
        ["INSURANCE"].includes(this.caseInformation.billing_type)
      ) {
        const payor = params.billing_info.insurance.primary_insurance.payor;
        const regex = /medicare/i;

        if (
          regex.test(payor) &&
          (this.pecosStatus === false || this.pecosStatus == null)
        ) {
          try {
            const confirmed = await ElMessageBox.confirm(
              "Physician PECOS status is not verified. Do you want to proceed?",
              "Warning",
              {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "warning",
              }
            );

            if (confirmed) {
              this.addNewCase();
            }
          } catch {
            ElMessage({
              type: "info",
              message: "Action canceled",
            });
          }
        } else {
          this.addNewCase();
        }
      } else {
        this.addNewCase();
      }
    },
    async addNewCase() {
      try {
        this.loading = true;
        let params = this.prepreDataFromFormData();
        params.billing_acknowledged = true;
        const response = await this.$store.dispatch("cases/addNewCase", params);
        this.newCase = true;
        const caseData = response?.data || this.getCaseCreationStatus?.data;
        const caseTypes = caseData?.case_types || [];
        if (caseTypes.includes("UTI")) {
          if (caseData?.sendoutCreated === true) {
            successNotification("Sendout case created successfully.");
          } else {
            errorNotification("Sendout case creation failed.");
          }
        }
        if (caseData) {
          successNotification("New Case Created Successfully");
          this.goBack();
        } else if (this.handleValidationError()) {
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(this.getError || "Error while creating New Case");
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("err")[0];

      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    goBack() {
      if (
        this.$route.params &&
        this.$route.params.case_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        const updatedQuery = { ...this.$route.query };
        if (updatedQuery.insuranceUpdate === "Replaced") {
          delete updatedQuery.insuranceUpdate;
        }
        this.$router.push({
          name: "AllCases",
          query: { ...updatedQuery, redirectRoute: this.$route.name },
        });
      }
    },
    async fetchAllPhysiciansByHospital(hospital) {
      try {
        if (Object.keys(this.hospitalsData).length > 0) {
          const selectedHospital = this.hospitalsData.data.find(
            (hospitalId) => hospitalId._id === hospital
          );
          if (selectedHospital) {
            // Retrieve the state from the selected hospital object
            this.selectedHospitalState = selectedHospital.state;
          }
        } // Print the selected hospital object to the console
        if (Object.keys(this.labdaqFacilityData).length > 0) {
          const selectedHospital = this.labdaqFacilityData.find(
            (hospitalId) => hospitalId._id === hospital
          );
          if (selectedHospital) {
            // Retrieve the state from the selected hospital object
            this.selectedHospitalState = selectedHospital.state;
          }
        } //
        this.caseInformation.ordering_physician = undefined;
        this.caseInformation.hospital_branch = null;
        let params = {
          hospital,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        if (this.getAllPhysicians.data && this.getAllPhysicians.data.length) {
          this.physicianOptions = this.getAllPhysicians.data;
          this.physiciansData = JSON.parse(
            JSON.stringify(this.getAllPhysicians)
          );
        }
        await this.$store.dispatch("branches/fetchAllBranches", {
          hospital_id: hospital,
        });
        this.hospitalBranches = this.getAllBranches.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      try {
        this.caseInformation.ordering_physician = undefined;

        if (hospitalBranch) {
          let params = {
            hospital_branch: hospitalBranch,
            get_all: true,
          };
          await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        } else {
          this.fetchAllPhysiciansByHospital(this.caseInformation.hospital);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAutoCompleteICDData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_string = searchString.trim();
        }
        if (
          this.caseInformation.case_types &&
          this.caseInformation.case_types.length &&
          this.includeAllICDCodes == false
        ) {
          params.primary_case_types = this.caseInformation.case_types[0];
        }
        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        const allIcdCodes = [];
        (this.getAllIcd10Codes.data || []).forEach((el) => {
          allIcdCodes.push({
            value: el.code + " - " + el.description,
            ...el,
          });
        });

        cb(allIcdCodes || []);
      } catch (err) {
        return cb([]);
      }
    },
    async getAutoCompleteCPTData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_code = searchString.trim();
        }

        await this.$store.dispatch("icd10Codes/fetAllCptCodes", params);
        const allCptCodes = [];
        (this.getAllCptCodes.data || []).forEach((el) => {
          allCptCodes.push({
            value: el.code,
            ...el,
          });
        });

        cb(allCptCodes || []);
      } catch (err) {
        return cb([]);
      }
    },
    selectICDCode(event, icdCodeData) {
      icdCodeData.value = event.code;
      this.previousSearchString = "";
    },
    selectCPTCode(event, cptData) {
      cptData.value = event.code;
    },
    getLabCaseTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.search_case_types = this.getUserBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },
    updateTestsPanelsData(event) {
      this.show = false;
      this.modalLoading = true;
      const loading = startLoading();
      if (event && event.data) {
        this.panelsTestsData.selectedTestIds = event.data.selectedTestIds;
        this.panelsTestsData.selectedCategories = event.data.selectedCategories;
        this.panelsTestsData.selectedGroup = event.data.selectedGroup;
        this.panelsTestsData.selectedTestsDetails =
          event.data.selectedTestsDetails;
        this.allTests = event.allTests;
      }
      let testIdsArray = [];
      if (
        this.caseInformation?.case_types.some((e) => ["CLINICAL_CHEMISTRY"])
      ) {
        const panelIdsArray = this.getNewLabGroupPanelTests
          .filter(
            (a) => a.panel_code === "ALL_TESTS" || a.panel_code === "SEND_OUTS"
          )
          .map((e) => e.panel_id);

        const panelIds = new Set(panelIdsArray);

        testIdsArray = this.panelsTestsData.selectedCategories
          .filter((e) => panelIds.has(e.panel_id))
          .flatMap((a) => a.test_ids);
      } else {
        testIdsArray = (this.panelsTestsData.selectedCategories || [])
          .filter((item) => item.all_tests !== true)
          .flatMap((item) => item.test_ids || []);
      }
      const sample_types = this.caseInformation.sample_types.flatMap((item) =>
        item.sample_types.map((sample) => ({
          case_type: item.case_type,
          sample_type: sample,
        }))
      );
      const isGroupCase = this.caseInformation?.case_types.some((type) =>
        [
          "UTI",
          "WOUND",
          "NAIL",
          "GASTRO",
          "RESPIRATORY_PATHOGEN_PANEL",
          "URINALYSIS",
          "STI",
          "WOMENS_HEALTH",
          "URINE_CULTURE",
          "ENT"
        ].includes(type)
      );
      const group_ids = isGroupCase
        ? this.panelsTestsData?.selectedGroup?.map((group) => group.group_id) ||
          []
        : [];
      const panel_info = this.panelsTestsData.selectedCategories;
      const panel_ids = panel_info.map((panel) => panel.panel_id);
      // API call for test tubes fetching
      this.$store.dispatch(
        "labSquireOrderTestTubes/fetchLabSquireOrderTestTubesInfo",
        {
          case_type: this.caseInformation.case_types
            ? Array.isArray(this.caseInformation.case_types)
              ? this.caseInformation.case_types
              : [this.caseInformation.case_types]
            : [],
          test_info: testIdsArray,
          lab_id: this.getUserPrimaryLabId,
          group_info: group_ids,
          panel_info: panel_ids,
          sample_types: sample_types,
        }
      );

      setTimeout(() => {
        this.addtestModelPopup = false;
        this.show = true;
        loading.close();
      }, 500);
    },
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el, index) => {
          if (
            el &&
            this.getTestsInformationObject[el] &&
            this.caseInformation.case_types.indexOf(
              this.getTestsInformationObject[el].case_type_code
            ) != -1
          ) {
            data.push(this.getTestsInformationObject[el]);
          } else {
            this.panelsTestsData.selectedTestIds.splice(index, 1);
          }
        });
      }

      return data;
    },
    getSelectedCaseTypes() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length
      ) {
        const caseTypes = this.caseInformation.case_types;
        const filteredCategories =
          this.panelsTestsData.selectedCategories.filter((category) =>
            caseTypes.includes(category.case_type_code)
          );
        const filteredGroups = this.panelsTestsData.selectedGroup.filter(
          (group) => caseTypes.includes(group.case_type_code)
        );
        let data = [...filteredCategories, ...filteredGroups];
        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },
    goToAllCases() {
      if (
        this.$route.params &&
        this.$route.params.case_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        this.$confirm("Are you sure to cancel adding new case?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          const updatedQuery = { ...this.$route.query };
          if (updatedQuery.insuranceUpdate === "Replaced") {
            delete updatedQuery.insuranceUpdate;
          }
          this.$router.push({
            name: "AllCases",
            query: { ...updatedQuery, redirectRoute: this.$route.name },
          });
        });
      }
    },
    popupScreen() {
      this.addtestModelPopup = true;
      this.modalLoading = true;
    },
    async checkCaseInformation() {
      try {
        this.loading = true;
        this.caseId = this.$route.params.case_id;
        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);

        if (!this.getCaseInformation) {
          this.disablePatientInformation = true;
        }
        await this.fetchData();
        if (this.getCaseInformation && this.getCaseInformation.hospital) {
          await this.fetchAllPhysiciansByHospital(
            this.getCaseInformation.hospital._id
          );
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.referring_physician
        ) {
          await this.fetchRefferingPhysicians();
        }
        this.showDob = false;

        if (this.getCaseInformation) {
          if (this.getCaseInformation.patient_info) {
            this.patientInformation = {
              ...this.getCaseInformation.patient_info,
            };
          }
          this.setCaseInformationData();
          if (this.getCaseInformation && this.getCaseInformation.sample_types) {
            this.caseInformation.sample_types =
              this.getCaseInformation.sample_types;
          }

          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.primary_insurance
          ) {
            this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getCaseInformation.billing_info.insurance.primary_insurance
            );
          }
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.secondary_insurance
          ) {
            this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getCaseInformation.billing_info.insurance.secondary_insurance
            );
          }
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.tertiary_insurance
          ) {
            this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getCaseInformation.billing_info.insurance.tertiary_insurance
            );
          }
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.guarantor
          ) {
            this.guarantorInsuranceForm =
              this.getCaseInformation.billing_info.insurance.guarantor;
          }
          this.toxicology_ereq_form = this.getCaseInformation
            .toxicology_ereq_form
            ? this.getCaseInformation.toxicology_ereq_form
            : [];
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.primary_insurance &&
            this.$route.query &&
            this.$route.query.insuranceUpdate === "Replaced"
          ) {
            this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getCaseInformation.billing_info.insurance.primary_insurance
            );
          }
        }

        await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
          lab_id: this.getCaseInformation.lab._id,
          case_type_code: this.getCaseInformation.case_types[0],
        });

        await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
          lab_id: this.getCaseInformation.lab._id,
          case_type_code: this.getCaseInformation.case_types[0],
        });

        await this.$store.dispatch("cases/fetchCaseTestsInfo", this.caseId);
        if (this.getSingleCaseTestsInfo) {
          this.panelsTestsData.selectedTestIds =
            this.getSingleCaseTestsInfo.map((el) => el._id);

          let casePanelsTestsInfo = this.getSingleCaseTestsInfo.filter(
            (test) => !test.group_id
          );
          let caseGroupsTestsInfo = this.getSingleCaseTestsInfo.filter(
            (test) => test.group_id
          );

          const transformedPanels = Object.values(
            casePanelsTestsInfo.reduce((acc, test) => {
              const key = `${test.panel_id}|${test.case_type_code}`;
              if (!acc[key]) {
                acc[key] = {
                  panel_id: test.panel_id,
                  case_type_code: test.case_type_code,
                  all_tests: true,
                  test_ids: [],
                };
              }
              acc[key].test_ids.push(test._id);
              return acc;
            }, {})
          );
          this.panelsTestsData.selectedCategories = transformedPanels;

          const uniqueGroups = Object.values(
            caseGroupsTestsInfo.reduce((acc, test) => {
              if (!acc[test.group_id]) {
                acc[test.group_id] = {
                  group_id: test.group_id,
                  group_code: test.group_code,
                  group_title: test.group_title,
                  case_type_code: test.case_type_code,
                };
              }
              return acc;
            }, {})
          );
          this.panelsTestsData.selectedGroup = uniqueGroups.map((e) => {
            e._id = e.group_id;
            e.panel_ids = Array.from(
              new Set(
                this.getSingleCaseTestsInfo
                  .filter((test) => test.group_id == e.group_id)
                  .map((test) => test.panel_id)
              )
            );
            e.case_type_code = e.case_type_code;
            return e;
          });
        }
        this.allTests = this.getSingleCaseTestsInfo;
        let testIdsArray = [];
        if (
          this.caseInformation?.case_types.some((e) => ["CLINICAL_CHEMISTRY"])
        ) {
          const panelIdsArray = this.getNewLabGroupPanelTests
            .filter(
              (a) =>
                a.panel_code === "ALL_TESTS" || a.panel_code === "SEND_OUTS"
            )
            .map((e) => e.panel_id);

          const panelIds = new Set(panelIdsArray);

          testIdsArray = this.panelsTestsData.selectedCategories
            .filter((e) => panelIds.has(e.panel_id))
            .flatMap((a) => a.test_ids);
        } else {
          testIdsArray = (this.panelsTestsData.selectedCategories || [])
            .filter((item) => item.all_tests !== true)
            .flatMap((item) => item.test_ids || []);
        }
        const sample_types = this.caseInformation.sample_types.flatMap((item) =>
          item.sample_types.map((sample) => ({
            case_type: item.case_type,
            sample_type: sample,
          }))
        );
        const isGroupCase = this.caseInformation?.case_types.some((type) =>
          [
            "UTI",
            "WOUND",
            "NAIL",
            "GASTRO",
            "RESPIRATORY_PATHOGEN_PANEL",
            "URINALYSIS",
            "STI",
            "WOMENS_HEALTH",
            "URINE_CULTURE",
            "ENT"
          ].includes(type)
        );
        const group_ids = isGroupCase
          ? this.panelsTestsData?.selectedGroup?.map(
              (group) => group.group_id
            ) || []
          : [];
        const panel_info = this.panelsTestsData.selectedCategories;
        const panel_ids = panel_info.map((panel) => panel.panel_id);
        // API call for test tubes fetching
        this.$store.dispatch(
          "labSquireOrderTestTubes/fetchLabSquireOrderTestTubesInfo",
          {
            case_type: this.caseInformation.case_types
              ? Array.isArray(this.caseInformation.case_types)
                ? this.caseInformation.case_types
                : [this.caseInformation.case_types]
              : [],
            test_info: testIdsArray,
            lab_id: this.getUserPrimaryLabId,
            group_info: group_ids,
            panel_info: panel_ids,
            sample_types: sample_types,
          }
        );

        setTimeout(() => {
          this.showDob = true;
        }, 100);
        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
    setCaseInformationData() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation) &&
        Object.keys(this.getCaseInformation).length
      ) {
        this.caseInformation.case_types = this.getCaseInformation.case_types;
        this.caseInformation.lab = this.getCaseInformation.lab
          ? this.getCaseInformation.lab._id
          : null;
        this.caseInformation.collection_date = this.convertLabUTCToClient(
          this.getCaseInformation.collection_date
        );
        this.caseInformation.received_date = this.convertLabUTCToClient(
          this.getCaseInformation.received_date
        );
        this.caseInformation.hospital = this.getCaseInformation.hospital
          ? this.getCaseInformation.hospital._id
          : null;
        this.searchHospital = this.getCaseInformation.hospital
          ? this.getCaseInformation.hospital.name
          : null;
        const casePhysician = this.getCaseInformation.ordering_physician;
        if (casePhysician) {
          const physicians = this.physiciansData?.data || [];
          const matched = physicians.find(p => casePhysician.npi_code && p.npi_code === casePhysician.npi_code)
            || physicians.find(p => p._id === casePhysician._id);
          this.caseInformation.ordering_physician = matched?._id || casePhysician._id || null;
        }
        this.caseInformation.referring_physician =
          this.getCaseInformation.referring_physician &&
          this.getCaseInformation.referring_physician._id
            ? this.getCaseInformation.referring_physician._id
            : null;
        this.caseInformation.hospital_branch = this.getCaseInformation
          .hospital_branch
          ? this.getCaseInformation.hospital_branch._id
          : null;
        this.caseInformation.icd_10_codes =
          this.getCaseInformation.icd_10_codes;
        this.caseInformation.billing_type =
          this.getCaseInformation.billing_type;
        this.caseInformation.order_id = this.getCaseInformation.order_id || "";
        this.caseInformation.specimen_collector =
          this.getCaseInformation.specimen_collector;
        this.caseInformation.specimen_source =
          this.getCaseInformation.specimen_source;
        this.caseInformation.patient_info =
          this.getCaseInformation.patient_info;
        if (!this.caseInformation.icd_10_codesForm) {
          this.caseInformation.icd_10_codesForm = [];
        }
        this.caseInformation.icd_10_codes.forEach((el, index) => {
          if (!this.caseInformation.icd_10_codesForm[index]) {
            this.caseInformation.icd_10_codesForm[index] = { sno: index + 1, value: '' };
          }
          this.caseInformation.icd_10_codesForm[index].value = el;
        });
        this.caseInformation.is_stat = this.getCaseInformation.is_stat;
        this.caseInformation.additional_fax =
          this.getCaseInformation.additional_fax &&
          this.getCaseInformation.additional_fax.length
            ? this.getCaseInformation.additional_fax
            : [];
        this.caseInformation.additional_fax_requisite = this.getCaseInformation
          .additional_fax_requisite
          ? this.getCaseInformation.additional_fax_requisite
          : "";
        this.caseInformation.cpt_codes = this.getCaseInformation.cpt_codes;
        this.caseInformation.cpt_codes.forEach((el, index) => {
          this.caseInformation.cpt_codesForm[index].value = el;
        });
      }
    },
  },
  watch: {
    "caseInformation.case_types": {
      immediate: true,
      handler: function () {
        this.hideTestsDetails = true;
        setTimeout(() => {
          this.hideTestsDetails = false;
        }, 1000);
      },
    },
  },
};
</script>

<style lang="scss">
.signature-settings {
  .case-creation__body {
    padding-bottom: 10px !important;
  }

  .el-checkbox {
    height: auto;
    margin-right: 10px;
    margin-bottom: -4px;
  }

  label {
    span {
      color: #f24a55;
      text-transform: uppercase;
    }
  }
}

.signature {
  background-color: #fff;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 90%;
  margin: auto;
  height: 125px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.signature-after-sign {
  img {
    width: 250px;
    height: 100px;
    padding: 1rem 0;
  }
}

.patient-popup {
  .attach-img {
    text-align: center;
    width: 100%;

    img {
      width: 150px;
    }
  }

  .attach-input {
    text-align: center;
    margin: 10px 0;
    width: 100%;
    padding: 5px 10px;
    background: none;
    position: relative;
    color: #fff;
    border-radius: 2px;
    text-align: center;
    float: left;
    cursor: pointer;

    .hide_file {
      position: absolute;
      z-index: 1000;
      opacity: 0;
      cursor: pointer;
      right: 0;
      top: 0;
      height: 100%;
      font-size: 24px;
      width: 100%;
    }
  }

  .el-tabs__item {
    color: #828282;
    font-weight: 500;
    text-transform: uppercase;
    padding: 0px 40px 0 0 !important;
  }

  .el-tabs__item.is-active {
    color: #0a5da6 !important;
    font-weight: 500;
  }

  .el-tabs__active-bar {
    background-color: #0a5da6 !important;
  }
}

.active-case-type-error {
  margin-top: 25px !important;
}

.uti-medical-necessity {
  .heading-block {
    margin-bottom: 10px;
  }

  h3 {
    font-size: 1em;
    color: #0a5da6;
    margin-bottom: 5px;
    border-left: 5px solid #0a5da6;
    padding-left: 5px;
  }

  h4 {
    font-size: 0.9em;
  }

  p {
    font-size: 0.9em;
    line-height: 20px;
  }

  .text-check-box {
    display: flex;
  }

  .el-checkbox {
    height: 25px;
    font-size: 13px;
  }

  label {
    margin-bottom: 5px;
  }

  .el-checkbox__input {
    background: #ffffff;
    border: 1.27979px solid #9c9c9c;
    box-sizing: border-box;
    border-radius: 3.83936px;
  }

  .el-checkbox__inner {
    border-radius: 2.55957px;
    margin: 1px;
    width: 13px;
    height: 13px;
    border: none;
  }

  .el-checkbox-group .el-checkbox__label {
    color: #34495e;
  }

  .el-checkbox__inner::after {
    content: "";
    border: 1.6px solid var(--el-checkbox-checked-icon-color);
    border-left: 0;
    border-top: 0;
    height: 6px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform 0.15s ease-in 50ms;
    transform-origin: center;
  }

  .el-checkbox__input .el-checkbox__inner {
    border-color: transparent;
    box-shadow: 0 0 0 1px transparent;
    border-radius: 4px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #0a5da6;
    border-color: #ffffff;
    box-shadow: 0 0 0 1px #ced1d6;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: rotate(45deg) scaleY(1);
  }
}

//Addtional Fax start
.vue-form {
  .mobile-icon {
    position: relative;

    .el-icon {
      position: absolute;
      right: 2%;
      top: 38%;
      opacity: 0.3;
    }
  }

  .additonal-fax {
    display: flex;
    gap: 20px;
  }

  .fax-btn {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .el-button {
      padding: 0 14px;

      min-height: 30px;
      background-color: #273480;
      color: #ffffff;
      border: none;
    }

    .fax-actions-view {
      display: flex;
      flex-wrap: wrap;

      margin: 0 10px;

      .el-tag {
        margin: 3px;
        padding: 0 5px 0 10px;
        border: none;
        height: 28px;
        font-weight: 500;
        border-radius: 12.7979px;
        line-height: 28px;
        background: #e7eff6;
        color: #0a5da6;
      }

      .btn-close-icon {
        display: flex;
        align-items: center;

        img {
          position: relative;
          top: 1px;
          cursor: pointer;
        }
      }
    }
  }
}

//Addtional Fax end
//Look Popup start
.empty-test-inner {
  margin-top: 5em;
  margin-bottom: 5em;
  text-align: center;

  .test-info {
    margin: 0 auto;

    img {
      width: 115px;
      margin: 10px;
    }
  }

  .content {
    text-align: center;

    p {
      color: #828282;
      line-height: 22px;
      font-size: 14px;
    }

    .el-button {
      margin: 14px 0;

      background: #0a5da6 !important;
      box-shadow: 0px 8px 16px -4px rgba(16, 38, 137, 0.1);
      border-radius: 10px;
      color: #fff;
      border: 0.7px solid #0a5da6;
    }
  }
}

//Look Popup End
//medication rempve start
.lists {
  margin: 0;
  display: flex;
  justify-content: flex-start;

  .remove-btn {
    .el-button {
      border: none;
      padding: 0;
      min-height: 20px;

      &:hover {
        background: none;
      }

      &:active {
        background: none;
      }

      &:focus {
        background: none;
      }
    }

    .el-dialog--center {
      border-radius: 5px;

      .el-dialog__body {
        text-align: initial;
        padding: 17px calc(var(--el-dialog-padding-primary) + 25px) 10px;
        text-align: center;

        span {
          img {
            vertical-align: top;
          }

          .view-cases {
            color: #0a5da6;
          }
        }
      }

      .el-dialog__footer {
        .dialog-footer {
          .el-button {
            border: 1.3px solid #dedbdb;
            color: #4f4f4f;
            padding: 5px;
            border-radius: 5px;

            &:hover {
              background-color: #f24a55;
              color: #fff;
              // border: none;
            }
          }

          .el-button--primary {
            background: none;
            padding: 5px 20px;

            &:hover {
              background-color: #215fad;
              color: #fff;
              // border: none;
            }
          }
        }
      }
    }

    .el-dialog__header {
      display: none;
    }
  }
}

//medication reomve end

.active-fax-type-error {
  margin-top: 0 !important;
}

.active-tabs {
  color: #eb5757;
  font-weight: 500;
}

.undo-btn {
  width: 80%;
  margin: auto;
  text-align: center;
}

.el-icon {
  cursor: pointer;
}

#insurance-details {
  border: 1.5px solid #e7e7f7;
  border-radius: 10px;
  margin: 15px;
  padding: 5px;

  .insurance-details-block {
    height: 500px;
    overflow: auto;
    padding: 5px 15px;

    ul {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 20px;

      .insurance-details-list {
        border: 1.5px solid #e7e7f7;
        margin: 5px 0;
        overflow: hidden;
        border-radius: 10px;

        .insurance-block {
          display: grid;
          // grid-template-columns: 1.5fr 3fr;
          align-items: baseline;
          column-gap: 20px;
          font-weight: 500;
          color: #000000;

          span:nth-child(2) {
            padding: 5px 15px;
          }
        }

        .insurance-label {
          color: #005475;
          font-weight: 600;
          font-size: 15px;
          text-transform: capitalize;
          background: #f3f3f3;
          padding: 5px 15px;
        }

        .insurance-sub-order {
          .insurance-sub-list {
            .insurance-sub-block {
              display: grid;
              grid-template-columns: 1.5fr 3fr;
            }
          }
        }

        .main-sub-block {
          .insurance-sub-block {
            border: 1.5px solid #e7e7f7;
            margin: 5px 0;
            overflow: hidden;
            border-radius: 10px;

            &.m-10 {
              margin: 10px;
            }
          }

          &:nth-child(8),
          &:nth-child(9),
          &:nth-child(10),
          &:nth-child(12),
          &:nth-child(13) {
            .Patient-details {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              column-gap: 20px;
              row-gap: 5px;
              color: #000000;
              margin: 0 10px;

              li {
                border: 1.5px solid #e7e7f7;
                margin: 5px 0;
                overflow: hidden;
                border-radius: 10px;

                span:nth-child(2) {
                  padding: 5px 15px;
                  display: inline-flex;
                }
              }

              .insurance-label {
                color: #273480;
                font-weight: 500;
              }
            }

            .insurance-sub-block {
              display: block;
            }
          }

          &:nth-child(16) {
            .insurance-sub-block {
              display: block;
            }

            .Patient-details {
              margin: 0 10px;
              grid-template-columns: 1fr;

              li {
                border: 1.5px solid #e7e7f7;
                margin: 5px 0;
                overflow: hidden;
                border-radius: 10px;

                span:nth-child(2) {
                  padding: 5px 15px;
                  display: inline-flex;
                }
              }
            }
          }
        }

        &:nth-child(7) {
          grid-column: 1 / span 3;

          .insurance-block {
            display: block;

            .insurance-sub-order {
              grid-template-columns: 1fr;
            }

            .insurance-sub-list {
              display: grid;
              grid-template-columns: 1fr;
              column-gap: 20px;
              margin: 10px;
            }
          }
        }
      }
    }
  }

  .sub-details-block {
    .Patient-details {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 20px;
      row-gap: 5px;
      color: #000000;
      margin: 10px;

      li {
        border: 1.5px solid #e7e7f7;
        margin: 5px 0;
        overflow: hidden;
        border-radius: 10px;

        span:nth-child(2) {
          padding: 5px 15px;
          display: inline-flex;
        }
      }

      .insurance-label {
        color: #273480;
        font-weight: 500;
      }
    }
  }
}
</style>
